import _ from 'lodash';

class UpgradeService {
    /*@ngInject*/
    constructor(cartService, dataContext, $q, constants, catalogService) {
        this.cartService = cartService;
        this.dataContext = dataContext;
        this.$q = $q;
        this.constants = constants;
        this.catalogService = catalogService;
    }

    getRequiredPlanUpgrade() {
        return this.cartService.getCart()
            .then((cart) => {
                return this.catalogService.getProduct(_.map(cart.data.items, 'productId'));
            })
            .then(productsResponse => {
                const products = productsResponse.data;
                const productSkus = _.map(products, (product) => { return product.sku.replace(/^__*/, '^'); });

                return this.dataContext.monitoringPlans.getRequiredPlan(productSkus).then((requiredPlan) => {
                    return !_.isNil(requiredPlan) ? requiredPlan : 'none';
                });
            });
    }

    getItemsRequiringUpgrade() {
        return this.dataContext.monitoringPlans.getItemsRequiringUpgrade();
    }
}

export default UpgradeService;